import { Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, useTheme } from '@mui/material'
import React from 'react'
import { getPaymentTypeBackground } from '../../../../common/helper'
import { useSelector } from 'react-redux'
import VirtualizedTable from '../../../../common/virtualisedTable'

const VehiclewiseTable = ({
  loginData,
  selBranch,
  selDestCity,
  selFromBranch,
  columnDefs,
  tableData,
  summaryColumn,
  summaryTableData,
  summarySelectedFields,
}) => {
  const theme = useTheme()
  const companySettings = useSelector((state) => state?.common?.companySettings[0])
  const loginCountryId = companySettings?.DefaultCurrencyID
  const { tableHeaderColor } = theme
  const updateTableData = tableData.map((item) => {
    return item.dataType === 'entry'
      ? {
          ...item,
          PaymentType: (
            <span
              style={{
                width: '120px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                whiteSpace: 'nowrap',
                padding: '4px 10px',
                background: 'F5FAFE',
                fontSize: '12px',
                fontWeight: item?.dataType === 'total' ? '600' : '500',
                color: '#444',
                color: 'black',
                borderRadius: '13px',
                textAlign: 'left',
                backgroundColor: getPaymentTypeBackground(item.PaymentType),
              }}
            >
              {item.PaymentType}
            </span>
          ),
          OnlyLRNo: `${item.LRNO}\n${item.ManualLR}`,
          VoucherNo: `${item.VoucherNo}\n ${item.PartyBillNo}`,
          BookCity: (
            <>
              <Tooltip title={item.BookCity} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {item.BookCity}
                </span>
              </Tooltip>
              <Tooltip title={item.SourceBranchName} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {item.SourceBranchName}
                </span>
              </Tooltip>
            </>
          ),
          DestCityBranch: (
            <>
              <Tooltip title={item.DestCity} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {item.DestCity}
                </span>
              </Tooltip>
              <Tooltip title={item.DestinationBranchName} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {item.DestinationBranchName}
                </span>
              </Tooltip>
            </>
          ),
          DispatchedToCityFilter: (
            <>
              <Tooltip title={item.DispatchedToCityFilter} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {item.DispatchedToCityFilter}
                </span>
              </Tooltip>
              <Tooltip title={item.DispatchedToBranchFilter} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {item.DispatchedToBranchFilter}
                </span>
              </Tooltip>
            </>
          ),
          PickupCity: (
            <>
              <Tooltip title={item.PickupCity} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {item.PickupCity}
                </span>
              </Tooltip>
              <Tooltip title={item.PickupBranch} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {item.PickupBranch}
                </span>
              </Tooltip>
            </>
          ),
          SenderName: (
            <>
              <Tooltip title={item.SenderName} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {item.SenderName}
                </span>
              </Tooltip>
              <Tooltip title={item.SenderMobileNo} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {item.SenderMobileNo}
                </span>
              </Tooltip>
              <Tooltip title={item.SenderGSTN} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {item.SenderGSTN}
                </span>
              </Tooltip>
              <Tooltip title={item.SenderEmailID} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {item.SenderEmailID}
                </span>
              </Tooltip>
            </>
          ),
          RecName: (
            <>
              <Tooltip title={item.RecName} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>{item.RecName}</span>
              </Tooltip>
              <Tooltip title={item.RecMobileNo} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {item.RecMobileNo}
                </span>
              </Tooltip>
              <Tooltip title={item.ReceiverGSTN} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {item.ReceiverGSTN}
                </span>
              </Tooltip>
              <Tooltip title={item.ReceiverEmailID} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {item.ReceiverEmailID}
                </span>
              </Tooltip>
            </>
          ),
          ItemDetails: (
            <Tooltip title={item.ItemDetails} placement="top-start">
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                {item.ItemDetails}
              </span>
            </Tooltip>
          ),
        }
      : item
  })
  const headerContent = () => {
    return (
      <>
        <TableRow style={{ backgroundColor: '#bfe1ff', color: '#444444' }}>
          <TableCell
            className="reportTD"
            style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left', color: '#444444', height: '36px' }}
            colSpan={Math.floor(columnDefs?.length / 3)}
          >
            Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
          </TableCell>
          <TableCell
            className="reportTD"
            style={{ fontSize: '12px', fontWeight: '600', textAlign: 'center', color: '#444444' }}
            colSpan={Math.floor(columnDefs?.length / 3)}
          >
            Destination City: {selDestCity?.name}
          </TableCell>

          <TableCell
            className="reportTD"
            style={{ fontWeight: '600', fontSize: '12px', textAlign: 'right', color: '#444444' }}
            colSpan={columnDefs.length - Math.floor(columnDefs?.length / 3) * 2}
          >
            Destination Branch: {selBranch?.name}
          </TableCell>
        </TableRow>
        <TableRow>
          {columnDefs.map((item, index) => (
            <TableCell
              className="ReportItemHead"
              key={`soed-${index}`}
              style={{
                ...item.headerSx,
                backgroundColor: '#e5f3ff',
                color: '#444',
                fontSize: '12px',
                fontWeight: '600',
                whiteSpace: 'pre',
                verticalAlign: 'top',
              }}
              colSpan={1}
            >
              {item.header}
            </TableCell>
          ))}
        </TableRow>
      </>
    )
  }

  const bodyContent = (index, obj) => {
    return <DisPatchBody row={obj} index={index} tableHeaderColor={tableHeaderColor} columnDefs={columnDefs} />
  }

  return (
    <>
      <Stack sx={{ marginLeft: 2, marginRight: 2, height: 380, paddingTop: '10px', paddingBottom: '16px' }} className='vehicle-wise-table-box'>
        <VirtualizedTable
          tableData={updateTableData}
          headerContent={headerContent}
          rowContent={bodyContent}
          tableStyle={{ tableLayout: 'auto', width: '100%' }}
          autoResize={false}
        />
      </Stack>
      <Stack sx={{ marginLeft: 2, marginRight: 2, paddingBottom: '16px' }}>
      <Table
        sx={{ marginRight: 2, marginTop: '0px', minWidth: '100%', borderTop: '1px solid #aeaeae' }}
        size="small"
        aria-label="a dense table"
      >
        <TableHead style={{ position: 'sticky', top: '0' }}>
          <TableRow>
            {summaryColumn.map((val, index) => {
              return (
                <TableCell
                  ley={`STH-${index}`}
                  style={{
                    ...val.headerSx,
                    backgroundColor: '#e5f3ff',
                    color: '#444',
                    fontSize: '12px',
                    fontWeight: '600',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {val.header}
                </TableCell>
              )
            })}
          </TableRow>
        </TableHead>

        <TableBody className="filter-data-row" style={{ textAlign: 'center', fontSize: '12px', fontWeight: '500', marginLeft: '5px' }}>
          {summaryTableData.map((item,index) => {
            return item.isNoData ? (
              <TableRow key={`dire-${index}`}>
                <TableCell
                  colSpan={columnDefs.length}
                  align="center"
                  style={{ minHeight: '36px', fontSize: '12px', fontWeight: 'bold', color: 'red' }}
                >
                  {item.caption}
                </TableCell>
              </TableRow>
            ) : (
              <TableRow key={`dire-${index}`} sx={{ backgroundColor: item?.dataType === 'total' ? '#eee' : '' }}>
                <TableCell colSpan={1}>
                  <span
                    style={{
                      width: '120px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      whiteSpace: 'nowrap',
                      padding: '4px 10px',
                      background: 'F5FAFE',
                      fontSize: '12px',
                      fontWeight: item?.dataType === 'total' ? '600' : '500',
                      color: '#444',
                      color: 'black',
                      borderRadius: '13px',
                      textAlign: 'left',
                      backgroundColor: getPaymentTypeBackground(item.PaymentType),
                    }}
                  >
                    {item.PaymentType}
                  </span>
                </TableCell>
                <TableCell
                  colSpan={1}
                  style={{
                    background: 'F5FAFE',
                    fontSize: '12px',
                    fontWeight: item?.dataType === 'total' ? '600' : '500',
                    color: '#444',
                    textAlign: 'right',
                  }}
                >
                  {item.Quantity}
                </TableCell>
                <TableCell
                  colSpan={1}
                  style={{
                    background: 'F5FAFE',
                    fontSize: '12px',
                    fontWeight: item?.dataType === 'total' ? '600' : '500',
                    color: '#444',
                    textAlign: 'right',
                  }}
                >
                  {Number(item.Freight).toFixed(2)}
                </TableCell>
                {summarySelectedFields.hasOwnProperty('DocumentCharges') && (
                  <TableCell
                    colSpan={1}
                    style={{
                      background: 'F5FAFE',
                      fontSize: '12px',
                      fontWeight: item?.dataType === 'total' ? '600' : '500',
                      color: '#444',
                      textAlign: 'right',
                    }}
                  >
                    {Number(item.DocumentCharges).toFixed(2)}
                  </TableCell>
                )}
                {summarySelectedFields.hasOwnProperty('CartageAmount') && (
                  <TableCell
                    colSpan={1}
                    style={{
                      background: 'F5FAFE',
                      fontSize: '12px',
                      fontWeight: item?.dataType === 'total' ? '600' : '500',
                      color: '#444',
                      textAlign: 'right',
                    }}
                  >
                    {Number(item.CartageAmount).toFixed(2)}
                  </TableCell>
                )}
                {summarySelectedFields.hasOwnProperty('HamaliCharges') && (
                  <TableCell
                    colSpan={1}
                    style={{
                      background: 'F5FAFE',
                      fontSize: '12px',
                      fontWeight: item?.dataType === 'total' ? '600' : '500',
                      color: '#444',
                      textAlign: 'right',
                    }}
                  >
                    {Number(item.HamaliCharges).toFixed(2)}
                  </TableCell>
                )}
                {summarySelectedFields.hasOwnProperty('OperatorHamaliChg') && (
                  <TableCell
                    colSpan={1}
                    style={{
                      background: 'F5FAFE',
                      fontSize: '12px',
                      fontWeight: item?.dataType === 'total' ? '600' : '500',
                      color: '#444',
                      textAlign: 'right',
                    }}
                  >
                    {Number(item.OperatorHamaliChg).toFixed(2)}
                  </TableCell>
                )}
                {loginCountryId !== 2 && summarySelectedFields.hasOwnProperty('ServiceTaxAmount') && (
                  <TableCell
                    colSpan={1}
                    style={{
                      background: 'F5FAFE',
                      fontSize: '12px',
                      fontWeight: item?.dataType === 'total' ? '600' : '500',
                      color: '#444',
                      textAlign: 'right',
                    }}
                  >
                    {Number(item.ServiceTaxAmount).toFixed(2)}
                  </TableCell>
                )}
                {loginCountryId !== 2 && summarySelectedFields.hasOwnProperty('CartageTax') && (
                  <TableCell
                    colSpan={1}
                    style={{
                      background: 'F5FAFE',
                      fontSize: '12px',
                      fontWeight: item?.dataType === 'total' ? '600' : '500',
                      color: '#444',
                      textAlign: 'right',
                    }}
                  >
                    {Number(item.CartageTax).toFixed(2)}
                  </TableCell>
                )}
                {loginCountryId !== 2 && summarySelectedFields.hasOwnProperty('OptHamaliGST') && (
                  <TableCell
                    colSpan={1}
                    style={{
                      background: 'F5FAFE',
                      fontSize: '12px',
                      fontWeight: item?.dataType === 'total' ? '600' : '500',
                      color: '#444',
                      textAlign: 'right',
                    }}
                  >
                    {Number(item.OptHamaliGST).toFixed(2)}
                  </TableCell>
                )}
                {summarySelectedFields.hasOwnProperty('Insurance') && (
                  <TableCell
                    colSpan={1}
                    style={{
                      background: 'F5FAFE',
                      fontSize: '12px',
                      fontWeight: item?.dataType === 'total' ? '600' : '500',
                      color: '#444',
                      textAlign: 'right',
                    }}
                  >
                    {Number(item.Insurance).toFixed(2)}
                  </TableCell>
                )}
                <TableCell
                  colSpan={1}
                  style={{
                    background: 'F5FAFE',
                    fontSize: '12px',
                    fontWeight: item?.dataType === 'total' ? '600' : '500',
                    color: '#444',
                    textAlign: 'right',
                  }}
                >
                  {Number(item.NetAmount).toFixed(2)}
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
      </Stack>  
    </>
  )
}

export default VehiclewiseTable



const DisPatchBody = ({ row, index, tableHeaderColor, columnDefs }) => {
  if (!row?.dataType) return null
  const getStyles = (field,align) => {
    const common = {
      minHeight: '36px',
      fontSize: '12px',
      color: '#444',
    }
    if (row.dataType === 'entry') {
      return {
        ...common,
        fontWeight: '500',
        textAlign: align || 'left',
      }
    }
    if (row.dataType === 'subHeader') {
      return {
        ...common,
        fontWeight: '600',
        backgroundColor: tableHeaderColor?.isSubHeadingColor,
        textAlign: row.align?.[field] || 'left',
        position: 'sticky',
        top: '80px',
      }
    }
    if (row.dataType === 'total') {
      return {
        ...common,
        fontWeight: '600',
        backgroundColor: tableHeaderColor?.isTotalColor,
        textAlign: row.align?.[field] || 'right',
      }
    }
  }

  return (
    <>
      {(() => {
        let skip = 0

        return columnDefs.map((item, i) => {
          if (skip > 0) {
            skip--
            return null
          }
          const colSpan = row.colSpan?.[item.field] || 1
          skip = colSpan - 1
          return (
            <TableCell
              className="reportTD"
              key={item.field + i + index}
              colSpan={colSpan}
              style={getStyles(item.field,item.Align)}
            >
              {row[item.field]}
            </TableCell>
          )
        })
      })()}
    </>
  )
}